import React from 'react';
import theme from '../../theme';
import { IconProps } from './props'

const DeleteIcon: React.FC<IconProps> = ({ id, iconColor = theme.textDark, ...rest }) => (
    <svg
        id={id}
        width="21"
        height="23" 
        viewBox="0 0 21 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.386719 5.24414C0.386719 4.69186 0.834434 4.24414 1.38672 4.24414H5.38672V3.24414C5.38672 2.44849 5.70279 1.68543 6.2654 1.12282C6.82801 0.560211 7.59107 0.244141 8.38672 0.244141H12.3867C13.1824 0.244141 13.9454 0.560211 14.508 1.12282C15.0706 1.68543 15.3867 2.44849 15.3867 3.24414V4.24414H19.3867C19.939 4.24414 20.3867 4.69186 20.3867 5.24414C20.3867 5.79643 19.939 6.24414 19.3867 6.24414H18.3867V19.2441C18.3867 20.0398 18.0706 20.8029 17.508 21.3655C16.9454 21.9281 16.1824 22.2441 15.3867 22.2441H5.38672C4.59107 22.2441 3.82801 21.9281 3.2654 21.3655C2.70279 20.8029 2.38672 20.0398 2.38672 19.2441V6.24414H1.38672C0.834434 6.24414 0.386719 5.79643 0.386719 5.24414ZM4.38672 6.24414V19.2441C4.38672 19.5094 4.49208 19.7637 4.67961 19.9512C4.86715 20.1388 5.1215 20.2441 5.38672 20.2441H15.3867C15.6519 20.2441 15.9063 20.1388 16.0938 19.9512C16.2814 19.7637 16.3867 19.5094 16.3867 19.2441V6.24414H4.38672ZM7.67961 2.53703C7.86715 2.3495 8.1215 2.24414 8.38672 2.24414H12.3867C12.6519 2.24414 12.9063 2.3495 13.0938 2.53703C13.2814 2.72457 13.3867 2.97892 13.3867 3.24414V4.24414H7.38672V3.24414C7.38672 2.97892 7.49208 2.72457 7.67961 2.53703Z"
            fill={iconColor}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.38672 9.24414C8.939 9.24414 9.38672 9.69186 9.38672 10.2441V16.2441C9.38672 16.7964 8.939 17.2441 8.38672 17.2441C7.83443 17.2441 7.38672 16.7964 7.38672 16.2441V10.2441C7.38672 9.69186 7.83443 9.24414 8.38672 9.24414Z"
            fill={iconColor}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.3867 9.24414C12.939 9.24414 13.3867 9.69186 13.3867 10.2441V16.2441C13.3867 16.7964 12.939 17.2441 12.3867 17.2441C11.8344 17.2441 11.3867 16.7964 11.3867 16.2441V10.2441C11.3867 9.69186 11.8344 9.24414 12.3867 9.24414Z"
            fill={iconColor}
        />
    </svg>
);

export { DeleteIcon };